import type { ReactNode } from "react";

/** Small uppercase pill with a glowing dot — heads every section.
 *  `tone="light"` is for dark/drenched bands (brighter accent, glass bg);
 *  `tone="pink"` is for the pink drenched band, where translucent tints just
 *  blend into the surface — flips to a solid white pill with brand text. */
export default function Eyebrow({
  children,
  tone = "default",
}: {
  children: ReactNode;
  tone?: "default" | "light" | "pink";
}) {
  const colors =
    tone === "light"
      ? "border-brand-500/40 bg-white/[0.07] text-brand-500"
      : tone === "pink"
        ? "border-white bg-white text-brand-600"
        : "border-brand-600/30 bg-brand-600/[0.08] text-brand-600";
  const dot = tone === "light" ? "bg-brand-500" : "bg-brand-600";
  return (
    <span
      className={`inline-flex items-center gap-[9px] rounded-full border px-[13px] py-1.5 text-[12.5px] font-semibold uppercase tracking-[0.13em] ${colors}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full shadow-[0_0_8px_var(--color-brand-500)] ${dot}`} />
      {children}
    </span>
  );
}
